import { EventType, WbaEventParams } from 'types/types'

export const sendEvent = (eventName: EventType, params?: WbaEventParams): void => {
  if (typeof window.wba === 'function') {
    window.wba(eventName, params)
  } else {
    console.warn(`Analytics script is not loaded. Event "${eventName}" was not sent.`)
  }
}
